import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const KEY = 'vokelle_cookie_notice_seen';

// Gizlilik Politikası zaten "pazarlama/izleme çerezi kullanılmaz, sadece
// teknik depolama vardır" diyor (bkz. content/legal.js madde 6) — bu yüzden
// klasik ikili "kabul et/reddet" çerez rızası yerine dürüst bir bilgilendirme
// çubuğu: var olmayan bir seçim sunmuyoruz, sadece bildiriyoruz.
export default function CookieNotice() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch (_) { /* localStorage kapalıysa banner gösterilmez */ }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(KEY, '1'); } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 900,
      background: 'var(--bg-1)', borderTop: '1px solid var(--border)',
      boxShadow: '0 -4px 20px rgba(0,0,0,0.12)',
    }}>
      <div className="container" style={{
        padding: '14px 24px', display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap',
      }}>
        <p style={{ margin: 0, flex: 1, minWidth: 240, color: 'var(--text-2)', fontSize: 13, lineHeight: 1.5 }}>
          {t('cookie.text')}{' '}
          <Link to="/gizlilik-politikasi" style={{ color: 'var(--accent)' }}>{t('cookie.privacy_link')}</Link>
        </p>
        <button className="btn btn-sm" onClick={dismiss} style={{ flexShrink: 0 }}>
          {t('cookie.accept')}
        </button>
      </div>
    </div>
  );
}
